import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { UiModalComponent } from "../../shared/ui";
import { CatalogProduct } from "../../models/catalog";
import { CatalogSearchComponent } from "../../components/catalog-search/catalog-search.component";

@Component({
  selector: 'app-catalog-modal',
  templateUrl: './catalog-modal.component.html',
  styleUrl: './catalog-modal.component.scss',
  standalone: true,
  imports: [UiModalComponent, CatalogSearchComponent]
})
export class CatalogModalComponent {
  @ViewChild(UiModalComponent) modal!: UiModalComponent;

  @Input() initialSearchTerm: string = '';
  @Input() householdId?: number;
  @Input() preselectProvider?: string;
  @Output() itemSelected = new EventEmitter<CatalogProduct>();
  @Output() modalClosed = new EventEmitter<void>();

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  onItemSelected(item: CatalogProduct) {
    this.itemSelected.emit(item);
    this.close();
  }

  onModalClosed() {
    this.modalClosed.emit();
  }
}
